import { Component } from '@angular/core';
import {IonicPage, NavController, NavParams, ViewController, Events} from 'ionic-angular';

/**
 * Generated class for the WorkplanUserPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-workplan-user',
  templateUrl: 'workplan-user.html',
})
export class WorkplanUserPage {

  userList: any;
  userListAll: any;

  constructor(public navCtrl: NavController, public navParams: NavParams, public viewCtrl: ViewController, public events: Events) {
    this.userList       = this.navParams.get("user");
    this.userListAll    = this.navParams.get("user");
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad WorkplanUserPage');
  }

  resetUser() {
      this.userList = this.userListAll;
  }

  showUserWorkplan(user: any) {
      this.viewCtrl.dismiss();
      this.events.publish('workplan:user', user);
  }

  getUser(ev: any) {
      // Reset items back to all of the items
      this.resetUser();

      // set val to the value of the searchbar
      const val = ev.target.value;

      // if the value is an empty string don't filter the items
      if (val && val.trim() != '') {
          this.userList = this.userList.filter((item) => {
              return (item.name.toLowerCase().indexOf(val.toLowerCase()) > -1 || item.surname.toLowerCase().indexOf(val.toLowerCase()) > -1);
          })
      }
  }

}



// WEBPACK FOOTER //
// ./src/pages/workplan-user/workplan-user.ts